import { useState, useEffect } from "react";

import axios from "axios";

import Input from '@/components/Input';
import InputFile from '@/components/InputFile';
import { getErrorMessage, checkInputErrors } from '@/utils/Errors';

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Button from '@/components/Button';
import Dropdown from '@/components/Dropdown';

import {
    Save as SaveIcon,
    Close as CancelIcon
} from '@mui/icons-material';

import { getFormData } from '@/utils/Format';
import { formatFilesToSend } from '@/utils/Columns';

export default function ResourceMaintenanceModal({t, open, setOpen, fullScreen, resource, setChanged, user, token, apiUrl, 
    language, sendMessage, handleLogin, users, plans, config, openUrlModal}){

    const { sxDialogMinHeight } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    const [ errors, setErrors ] = useState(null);
    const [ data, setData ] = useState({
        plan: null,
        responsible: null,
        observations: '',
        files: null
    });

    const resetData = () => {
        setData({
            plan: null,
            responsible: null,
            observations: '',
            files: null
        });
    }

    useEffect(() => {
        resetData();
        setErrors(null);
    },[open]);

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    // to manage the users
    const handleResponsible = (newItem) => {
        var newData = {...data};
        newData.responsible = newItem;
        setData(newData);
    }

    // to manage the plans
    const handlePlan = (newItem) => {
        var newData = {...data};
        newData.plan = newItem;
        setData(newData);
    }

    const handleSubmit = () => {
        
        // return to campa
        let fieldsNotEmpty;
        if(resource?.situation?.rented){
            fieldsNotEmpty = ['responsible'];
        }
        else{
            // register exit
            fieldsNotEmpty = ['plan','responsible'];
        }

        setErrors(null);
        const errorsCheck = checkInputErrors(data,fieldsNotEmpty);

        if(Object.keys(errorsCheck).length === 0){

            // if rented, do the opposite
            let apiPath;
            if(resource?.situation?.rented){
                apiPath = '/resource_rental/remove';
            }
            else{
                apiPath = '/resource_rental/set';
            }

            const config = {
                headers: { Authorization: `Bearer ${token}` } 
            };            

            // return to campa
            const params = {
                language: language,
                companyuser: user?.company,
                resource: resource?.id,                
                responsible: data?.responsible?.id,
                observations: data?.observations
            };

            if(resource?.situation?.rented){
                params.plan = resource?.situation?.event?.plan?.id;
            }
            else{
                // register exit
                params.plan = data?.plan?.id;
            }

            params.files = formatFilesToSend(data.files);

            const send = getFormData(null,params,null,['files']);

            var errorMessage = t('resource_rentals.rentals.error');
            
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {

                if(response?.data){
              
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){
                        // the opposite
                        const status = resource?.situation?.rented ? 'in' : 'out';
                        sendMessage(t('resource_rentals.rentals.'+status+'.status'),resource?.situation?.rented ? 'success' : 'success');
                        
                        if(responseData?.data?.reload){
                            window.location.reload();
                        }
                        else{
                            const newResource = responseData?.data?.resource;
                            setChanged(newResource);
                            setOpen(false);
                        }
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            
                            // check error message
                            if(responseData?.data?.error){
                                
                                errorMessage = t('resource_rentals.rentals.errors.'+responseData?.data?.error);   
                                
                                // if error and resource, refresh the data
                                if(responseData?.data?.resource){
                                    setChanged(responseData?.data?.resource);
                                    setOpen(false);
                                }
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
        else{            
            const errorMessage = getErrorMessage(t,'resource_rentals.rentals',errorsCheck);
            setErrors(errorsCheck);
            sendMessage(errorMessage,'error');
        }
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialogMinHeight}
            onClose={handleClose}
            open={open}
            fullWidth={true}            
        >                        
            <DialogTitle className='modal-title'>
                {resource?.name}
            </DialogTitle>            
            <DialogContent className='modal-content'>
                <div className='mb-4 text-center'>
                    {
                        resource?.situation?.rented ? 
                            t('resource_rentals.rentals.in.register')
                        :
                            t('resource_rentals.rentals.out.register')
                    }                    
                </div>
                <div className='mb-4'>
                {
                    resource?.situation?.rented ?
                        <div className='font-bold border app-border-color-gradient rounded p-2 app-bg-gradient '>
                            <div className='border-b app-border-color-gradient text-center mb-2'>
                                {t('resource_rentals.rentals.fields.plan')} {t('resource_rentals.rentals.plan.in')}
                            </div>
                            <div className='text-center'>
                            {
                                resource?.situation?.location && resource?.situation?.location?.length > 0 ?
                                    <a href={resource?.situation.location} target='_blank'>{resource?.situation?.event?.plan?.name}</a>
                                :
                                    resource?.situation?.event?.plan?.name
                            }
                            </div>
                        </div>
                    :
                        <Dropdown                    
                            type='search'
                            name='plan'
                            value={data.plan}
                            placeholder={t('resource_rentals.rentals.fields.plan')}
                            options={plans}
                            handleDropdown={handlePlan}
                            error={errors && errors?.plan ? t('resource_rentals.rentals.errors.'+errors.plan) : ''}
                        />                    
                }
                </div>
                <div className='mb-4'>
                    <Dropdown                    
                        type='search'
                        name='responsible'
                        value={data.responsible}
                        placeholder={t('resource_rentals.rentals.fields.responsible')}
                        options={users}
                        handleDropdown={handleResponsible}
                        error={errors && errors?.responsible ? t('resource_rentals.rentals.errors.'+errors.responsible) : ''}
                    />
                </div>
                <div className='mb-4'>
                    <Input                      
                        name="observations"
                        type="multiline"
                        rows={6}
                        value={data.reason}                      
                        placeholder={t('resource_rentals.rentals.fields.observations')}
                        onChange={handleInput}
                        error={errors && errors?.observations ? t('resource_rentals.rentals.errors.'+errors.observations) : ''}                        
                    />
                </div>
                <div className='mb-4'>                    
                    <InputFile
                        t={t}
                        table='resource_rentals'
                        field='files'
                        files={data.files}
                        data={data}
                        setData={setData}
                        openUrlModal={openUrlModal}
                        config={config}
                        errors={errors}
                        editable={true}
                        size='small'
                    />
                </div>
            </DialogContent>            
            <div className="modal-buttons">
                <div className='mr-1'>
                    <SaveIcon className='action-button-modal text-green-800' onClick={handleSubmit}/>
                </div>                                
                <div className='mr-1'>
                    <CancelIcon className='action-button-modal text-red-800' onClick={handleClose}/>
                </div>
            </div>        
        </Dialog>
  );
}